module.exports = __webpack_public_path__ + "static/media/18_tn.60f52b65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/18_tn.jpg
// module id = 232
// module chunks = 0